// anchor id for lesson cover
export const ANCHOR_LESSON_COVER = "cover";

export const LINK_TYPE = {
  PAGE: "page",
  ACTIVITY: "activity",
  LESSON: "lesson",
};

// attributes
export const ATTRIBUTE = {
  DATA_ANCHOR: "data-anchor",
  DATA_CUSTOM_TEXT: "data-custom-text",
  DATA_LINK_TYPE: "data-link-type",
  DATA_LABEL: "data-label",
  DATA_VALID: "data-valid",
};

// class
export const CLASS = {
  DYNAMIC_LINK_WRAPPER: "sls-dynamic-link-wrapper",
  DYNAMIC_LINK_WRAPPER_HAS_ICON: "has-icon",
  DYNAMIC_LINK: "sls-dynamic-link",
  TAG: "sls-dynamic-link-tag",
  COMPONENT: "sls-dynamic-link-component",
  DYNAMIC_LINK_EDIT_MODAL_WRAPPER: "sls-dynamic-link-edit-modal-wrapper",
  CUSTOM_TOOLTIP: "custom-tooltip",
};

//selectors of the classes
export const SELECTOR = Object.entries(CLASS).reduce((accumulator, [key, className]) => {
  accumulator[key] = `.${className}`;
  return accumulator;
}, {});
